import { UntypedFormGroup } from "@angular/forms";
import { SaveSheetService } from "src/app/angular-core/services/save-sheet.service";

export function updateSaveSheet(formGroup: UntypedFormGroup, reference: any, saveSheetService: SaveSheetService): void {
  if (formGroup.dirty) {
    if (checkFormPristine(formGroup, reference)) {
      formGroup.markAsPristine();
      saveSheetService.change(false);
    }
    else if (!saveSheetService.openStatus$.value) {
      saveSheetService.change(true);
    }
  }

  // Never allow saving of invalid forms
  if (!formGroup.valid) {
    saveSheetService.change(false);
  }
}

export function updateSaveSheetMultiple(formGroups: UntypedFormGroup[], references: any[], saveSheetService: SaveSheetService): void {
  let anyInvalid: boolean = false;
  let anyDirty: boolean = false;

  if (formGroups.length !== references.length) {
    throw Error('Need a reference for each form group');
  }

  formGroups.forEach((group: UntypedFormGroup, index: number) => {
    if (group.dirty) {
      if (checkFormPristine(group, references[index])) {
        group.markAsPristine();
      }
      else {
        anyDirty = true;
      }
    }

    if (!group.valid && !group.disabled) {
      anyInvalid = true;
    }
  });

  const openSaveSheet: boolean = anyDirty && !anyInvalid;
  if (openSaveSheet !== saveSheetService.openStatus$.value) {
    saveSheetService.change(openSaveSheet);
  }
}

export function createReference(dataObject: any): any {
  return Object.assign({}, dataObject)
}
  
export function checkFormPristine(formGroup: UntypedFormGroup, reference: any): boolean {
  for (let key in formGroup.value) {
    if (formGroup.value[key] !== reference[key]) {
      if (formGroup.value[key] !== "" || reference[key] !== undefined) {
        return false;
      }
    }
  }
  return true;
}

export function resetForm(formGroup: UntypedFormGroup, dataObject: any) {
  Object.keys(dataObject).forEach((control) => {
    if (formGroup.get(control)) {
      formGroup.get(control).setValue(dataObject[control], {emitEvent: false});
    }
  });
}